import { gql } from "@apollo/client";
import PropTypes from "prop-types";

export const PERSON_QUERY = gql`
  query ($id: Int!, $first: Int, $offset: Int) {
    person(id: $id) {
      id
      name
      resultSet(first: $first, offset: $offset) {
        count
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            time
            status
            percentBehind
            minutesPerKilometer
            runcap
            ocap
            classresult {
              name
              id
              event {
                id
                name
                date
              }
            }
          }
        }
      }
    }
  }
`;